import { BrochureLanguageCode } from "src/utils/brochures";
import { isPresent } from "src/utils/checks";
import { LanguageCode } from "src/utils/localization/languages/types";
import { BrochureFragment } from "types/graphql-types";

type BrochureLanguage = { title: string; value: BrochureLanguageCode };

const allBrochuresLanguages: BrochureLanguage[] = [
  { title: "English", value: "en" },
  { title: "Deutsch", value: "de" },
  { title: "Español", value: "es" },
  { title: "Français", value: "fr" },
  { title: "Italiano", value: "it" },
  { title: "Português", value: "pt-br" },
  { title: "Русский язык", value: "ru" }
];

export function getDefaultLanguage(
  languageGroups: BrochureLanguage[],
  pageLanguageCode: LanguageCode
): LanguageCode {
  return languageGroups.find(({ value }) => value == pageLanguageCode)
    ? pageLanguageCode
    : "en";
}

export function getActiveLanguages(
  brochures: BrochureFragment[]
): BrochureLanguage[] {
  const brochuresLanguages = (brochures || [])
    .filter(isPresent)
    .map((b) => b.language);
  const uniqueBrochureLanguages = Array.from(new Set(brochuresLanguages));

  return allBrochuresLanguages.filter((g) =>
    uniqueBrochureLanguages.includes(g.value)
  );
}
